module.exports = __webpack_public_path__ + "static/10-4128e3ff0272621f02eef2c6efb079bb.jpg";